import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import moment from 'moment';

const PainelDadosProposta = ({ proposta }) => {
  if (!proposta) return null;

  const formatDate = (d) => (d ? moment(d).format('DD/MM/YYYY') : '-');
  const formatMoney = (v) =>
    v != null
      ? Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : '-';

  return (
    <Card className="mb-2">
      <Card.Header className="py-1">
        <strong>Dados da Proposta</strong>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Tipo</Form.Label>
              <Form.Control readOnly value={proposta.aux_tipo || '-'} />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Data Efetivação</Form.Label>
              <Form.Control readOnly value={formatDate(proposta.data_efetivacao)} />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Valor Face</Form.Label>
              <Form.Control readOnly value={formatMoney(proposta.valor_face)} />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Valor Compra</Form.Label>
              <Form.Control readOnly value={formatMoney(proposta.valor_compra)} />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Prazo Médio</Form.Label>
              <Form.Control readOnly value={proposta.prazo_medio != null ? Number(proposta.prazo_medio).toFixed(2) : '-'} />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">Cedente</Form.Label>
              <Form.Control readOnly value={proposta.cedente || '-'} />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PainelDadosProposta;
